// Foamy chat bubble: self-contained, RTL, no libraries. Talks to https://foamy-il.pages.dev/api/chat.
(function () {
  if (window.__fmChat) return; window.__fmChat = 1;
  var API = 'https://foamy-il.pages.dev/api/chat';
  var CONTACT = 'https://foamyclean.com/pages/contact';
  var K = 'fm-chat', st = { session: '', messages: [], seen: 0 };
  try { st = Object.assign(st, JSON.parse(localStorage.getItem(K) || '{}')); } catch (e) {}
  if (!st.session) st.session = (crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2, 12));
  function save() { try { localStorage.setItem(K, JSON.stringify({ session: st.session, messages: st.messages.slice(-24), seen: st.seen })); } catch (e) {} }
  save();
  var bb = document.getElementById('buyBox');
  var page = (bb && bb.dataset.page) || location.pathname.replace(/^\/(pages\/)?/, '').replace(/\/$/, '') || 'home';
  var GREET = 'היי! 👋 אני כאן לכל שאלה על ספריי הניקוי. מה תרצו לדעת?';
  var CHIPS = ['איך זה עובד?', 'כמה זמן משלוח?', 'זה יוריד כתם ישן?'];

  var css = '.fmc-b{position:fixed;right:12px;bottom:84px;z-index:30;width:48px;height:48px;border-radius:50%;border:0;background:#12a58a;color:#fff;display:grid;place-items:center;box-shadow:0 6px 18px rgba(0,0,0,.22);cursor:pointer}' +
    '.fmc-b:focus-visible,.fmc-p button:focus-visible,.fmc-p a:focus-visible,.fmc-p input:focus-visible{outline:3px solid #14213d;outline-offset:2px}' +
    '.fmc-b .dot{position:absolute;top:4px;right:4px;width:12px;height:12px;border-radius:50%;background:#c2410c;border:2px solid #fff}' +
    '.fmc-p{position:fixed;right:12px;bottom:150px;z-index:31;width:360px;max-width:calc(100vw - 24px);height:min(520px,calc(100vh - 170px));background:#fff;color:#14213d;border-radius:16px;box-shadow:0 14px 40px rgba(0,0,0,.25);display:flex;flex-direction:column;overflow:hidden;font-family:Heebo,system-ui,sans-serif;direction:rtl;text-align:right}' +
    '.fmc-p[hidden]{display:none}' +
    '.fmc-h{background:#14213d;color:#fff;padding:12px 14px;display:flex;align-items:center;justify-content:space-between;font-weight:800;font-size:16px}' +
    '.fmc-h small{display:block;font-weight:400;font-size:12px;opacity:.8}' +
    '.fmc-x{background:none;border:0;color:#fff;font-size:26px;line-height:1;cursor:pointer;padding:2px 8px;border-radius:8px}' +
    '.fmc-l{flex:1;overflow-y:auto;padding:12px;display:flex;flex-direction:column;gap:8px;background:#fbf8f3}' +
    '.fmc-m{max-width:85%;padding:9px 12px;border-radius:14px;font-size:15px;line-height:1.5;white-space:pre-wrap;word-wrap:break-word}' +
    '.fmc-m.u{align-self:flex-start;background:#12a58a;color:#fff;border-bottom-right-radius:4px}' +
    '.fmc-m.a{align-self:flex-end;background:#fff;border:1px solid #e7e1d6;border-bottom-left-radius:4px}' +
    '.fmc-m.o{align-self:flex-end;background:#e2f5f0;border:1px solid #12a58a}' +
    '.fmc-c{display:flex;flex-wrap:wrap;gap:6px}' +
    '.fmc-c button,.fmc-buy{border:1.5px solid #12a58a;background:#fff;color:#0b7f6a;border-radius:99px;padding:6px 12px;font:inherit;font-size:14px;font-weight:700;cursor:pointer;text-decoration:none;display:inline-block}' +
    '.fmc-buy{background:#12a58a;color:#fff;align-self:flex-end}' +
    '.fmc-t{align-self:flex-end;display:flex;gap:4px;padding:12px;background:#fff;border:1px solid #e7e1d6;border-radius:14px}' +
    '.fmc-t i{width:7px;height:7px;border-radius:50%;background:#3d4a66;animation:fmcb 1s infinite}' +
    '.fmc-t i:nth-child(2){animation-delay:.15s}.fmc-t i:nth-child(3){animation-delay:.3s}' +
    '@keyframes fmcb{0%,60%,100%{opacity:.25}30%{opacity:1}}' +
    '@media (prefers-reduced-motion:reduce){.fmc-t i{animation:none;opacity:.6}}' +
    '.fmc-f{display:flex;gap:6px;padding:10px;border-top:1px solid #e7e1d6;background:#fff}' +
    '.fmc-f input{flex:1;min-width:0;border:1.5px solid #e7e1d6;border-radius:12px;padding:10px 12px;font:inherit;font-size:16px;color:#14213d}' +
    '.fmc-f button{border:0;background:#14213d;color:#fff;border-radius:12px;padding:0 16px;font:inherit;font-weight:800;cursor:pointer}' +
    '.fmc-f button:disabled{opacity:.5;cursor:default}' +
    '.fmc-n{font-size:11.5px;color:#3d4a66;padding:0 12px 8px;background:#fff}.fmc-n a{color:#0b7f6a}' +
    '.fmc-sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)}' +
    '@media (max-width:480px){.fmc-p{right:0;left:0;bottom:0;width:100%;max-width:100%;height:85vh;border-radius:16px 16px 0 0}}';
  var s = document.createElement('style'); s.textContent = css; document.head.appendChild(s);

  var btn = document.createElement('button');
  btn.type = 'button'; btn.className = 'fmc-b'; btn.setAttribute('aria-label', 'צ\'אט עם פואמי: שאלות על המוצר');
  btn.setAttribute('aria-expanded', 'false'); btn.setAttribute('aria-controls', 'fmcPanel');
  btn.innerHTML = '<svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true"><path d="M4 5h16v11H9l-5 4z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><circle cx="9" cy="10.5" r="1.2" fill="currentColor"/><circle cx="12" cy="10.5" r="1.2" fill="currentColor"/><circle cx="15" cy="10.5" r="1.2" fill="currentColor"/></svg>';

  var p = document.createElement('div');
  p.className = 'fmc-p'; p.id = 'fmcPanel'; p.hidden = true;
  p.setAttribute('role', 'dialog'); p.setAttribute('aria-label', 'צ\'אט עם פואמי');
  p.innerHTML = '<div class="fmc-h"><div>פואמי<small>עונים על כל שאלה</small></div><button type="button" class="fmc-x" aria-label="סגירת הצ\'אט">×</button></div>' +
    '<div class="fmc-l" role="log" aria-live="polite" aria-relevant="additions"></div>' +
    '<form class="fmc-f"><label class="fmc-sr" for="fmcIn">ההודעה שלך</label><input id="fmcIn" type="text" maxlength="500" autocomplete="off" placeholder="כתבו שאלה…"><button type="submit">שליחה</button></form>' +
    '<div class="fmc-n">עוזר אוטומטי. אל תכתבו כאן פרטי אשראי. <a href="' + CONTACT + '">צור קשר</a></div>';
  document.body.appendChild(btn); document.body.appendChild(p);
  var list = p.querySelector('.fmc-l'), form = p.querySelector('form'), input = p.querySelector('input'), send = form.querySelector('button');

  function bubble(role, text) {
    var d = document.createElement('div'); d.className = 'fmc-m ' + (role === 'user' ? 'u' : role === 'owner' ? 'o' : 'a');
    d.textContent = text; list.appendChild(d); list.scrollTop = list.scrollHeight; return d;
  }
  function buyBtn() {
    var a = document.createElement('a'); a.className = 'fmc-buy'; a.textContent = 'לקנייה';
    var order = document.getElementById('order');
    a.href = order ? '#order' : '/pages/sofa#order';
    a.addEventListener('click', function (e) {
      if (order) { e.preventDefault(); close(); order.scrollIntoView({ behavior: 'smooth' }); var f = order.querySelector('input,button'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 500); }
    });
    list.appendChild(a); list.scrollTop = list.scrollHeight;
  }
  function chips() {
    var c = document.createElement('div'); c.className = 'fmc-c';
    CHIPS.forEach(function (t) {
      var b = document.createElement('button'); b.type = 'button'; b.textContent = t;
      b.addEventListener('click', function () { c.remove(); ask(t); }); c.appendChild(b);
    });
    list.appendChild(c);
  }
  function render() {
    list.innerHTML = ''; bubble('assistant', GREET);
    st.messages.forEach(function (m) { bubble(m.role, m.content); });
    if (!st.messages.length) chips();
  }

  var busy = false;
  function ask(text) {
    text = String(text || '').trim(); if (!text || busy) return;
    busy = true; send.disabled = true;
    st.messages.push({ role: 'user', content: text }); save(); bubble('user', text);
    var t = document.createElement('div'); t.className = 'fmc-t'; t.setAttribute('aria-label', 'כותבים תשובה'); t.innerHTML = '<i></i><i></i><i></i>';
    list.appendChild(t); list.scrollTop = list.scrollHeight;
    var payload = st.messages.filter(function (m) { return m.role !== 'owner'; }).slice(-12);
    fetch(API, { method: 'POST', headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ session: st.session, page: page, messages: payload }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var reply = d.reply || 'סליחה, לא הצלחתי לענות כרגע. נסו שוב עוד רגע.';
        st.messages.push({ role: 'assistant', content: reply }); st.messages = st.messages.slice(-24); save();
        t.remove(); bubble('assistant', reply); if (d.buy) buyBtn();
      })
      .catch(function () { t.remove(); bubble('assistant', 'אין חיבור כרגע. נסו שוב עוד רגע.'); })
      .then(function () { busy = false; send.disabled = false; input.focus(); });
  }

  function poll() {
    fetch(API, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ session: st.session, poll: true }) })
      .then(function (r) { return r.ok ? r.json() : { replies: [] }; })
      .then(function (d) {
        var r = d.replies || []; if (r.length <= st.seen) return;
        r.slice(st.seen).forEach(function (m) { st.messages.push({ role: 'owner', content: m.content }); if (!p.hidden) bubble('owner', m.content); });
        st.seen = r.length; save();
        if (p.hidden && !btn.querySelector('.dot')) { var dot = document.createElement('span'); dot.className = 'dot'; dot.setAttribute('aria-hidden', 'true'); btn.appendChild(dot); btn.setAttribute('aria-label', 'צ\'אט עם פואמי: יש תשובה חדשה'); }
      }).catch(function () {});
  }
  var timer = null;

  function open() {
    render(); p.hidden = false; btn.setAttribute('aria-expanded', 'true');
    var dot = btn.querySelector('.dot'); if (dot) dot.remove();
    input.focus(); poll(); timer = setInterval(poll, 30000);
  }
  function close() {
    p.hidden = true; btn.setAttribute('aria-expanded', 'false'); clearInterval(timer); btn.focus();
  }
  btn.addEventListener('click', function () { p.hidden ? open() : close(); });
  p.querySelector('.fmc-x').addEventListener('click', close);
  form.addEventListener('submit', function (e) { e.preventDefault(); var v = input.value; input.value = ''; ask(v); });
  p.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.stopPropagation(); close(); return; }
    if (e.key === 'Tab') { // keep focus inside the dialog
      var f = [].slice.call(p.querySelectorAll('button:not([disabled]),a[href],input')).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  if (st.messages.length) poll(); // someone who chatted before may have a reply waiting
})();
